{
  "register-form-page": {
    "title": "Please fill up the form to register LINE BK",
    "input-placeholder-one": "Citizen ID",
    "input-placeholder-three": "Mobile number",
    "button-two": "Request OTP",
    "fail": {
      "temporaly-unavailable": "The service is temporaly unavailable. Please try again",
      "contact-branch": "Please contact available branch",
      "wrong-phoneNo-docNo": "Incorrect citizen ID or mobile number",
      "request-otp": ""
    },
    "verification": {
      "title": "Please fill in mobile number to verify LINE BK"
    }
  },
  "otp-page": {
    "title": "Please fill in OTP to verify your identity",
    "description_1": "OTP reference code will be sent via SMS to ",
    "description_2": " This OTP is valid for 6 minutes only (referal code: ",
    "button-two": "Confirm",
    "dont-get-otp": "Did not receive OTP ?",
    "request-for-new-otp": " Request OTP again",
    "wrong-otp": "OTP reference code is incorrect, please fill in OTP again.",
    "timeout-otp": "Your OTP is expired. Please try again"
  },
  "term-condition-page": {
    "title": "Service terms and conditions",
    "version": "1",
    "description": "<p>ผู้ใช้บริการตกลงใช้บริการ LINE BK OA ซึ่งให้บริการดังนี้</p><p><br/></p><p>1. ข้อมูลผลิตภัณฑ์เงินฝากและผลิตภัณฑ์สินเชื่อ LINE BK</p><p>2. ติดต่อสอบถาม แจ้งปัญหาเกี่ยวกับผลิตภัณฑ์เงินฝาก และผลิตภัณฑ์สินเชื่อ LINE BK</p>",
    "check-box-label": "Agree with all terms and conditions",
    "button-one": "Cancel",
    "button-two": "Confirm"
  },
  "alert-page": {
    "imgUrl": {
      "success": "https://upload.convolab.ai/kline-bkdev%2F3779b04b-ec40-475c-b32b-d187daa73734.png",
      "fail": "https://upload.convolab.ai/kline-bkdev%2Fddae0c95-600f-4b0d-8c4f-9ed20b4c234a.png"
    },
    "title": "Sorry",
    "description": {
      "success": "Thank you for register with LINE BK",
      "fail": "You had already registered with LINE BK",
      "fail_not_register": "You have not yet register with LINE BK",
      "fail_timeout": "Please contact LINE BK admin"
    }
  },
  "validate-message": {
    "identity": "Please fill your citizen ID",
    "mobile": "Incorrect mobile number. Please try again",
    "sign-in": {
      "wrong-employee-code": "ไม่พบรหัสพนักงาน",
      "wrong-mobile-phone-no": "หมายเลขโทรศัพท์มือถือไม่ถูกต้อง",
      "service-error": "ไม่สามารถทำรายการได้ในขณะนี้ โปรดปิดหน้าจอ เพื่อติดต่อเจ้าหน้าที่"
    }
  }
}
